import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ManifestSwitcher = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return;
    link.href = pathname.startsWith('/admin')
      ? '/manifest.json'
      : '/manifest-passenger.json';
  }, [pathname]);

  return null;
};

export default ManifestSwitcher;
